import Column from '@components/Column';
import { ItemOption } from '@models/item';
import { OrderOption } from '@models/order';
import { Fragment } from 'react';

import SelectedOptionRow from './SelectedOptionRow';
import useSelectedPersonalOptions from './useSelectedPersonalOptions';

interface Props {
    itemId: string;
}

/**
 * 선택된 퍼스널 옵션 목록
 * @param itemId
 * @constructor
 */
function SelectedPersonalOptionList({ itemId }:Props) {
    const optionsWithGroups = useSelectedPersonalOptions();

    if (optionsWithGroups.length === 0) {
        return null;
    }
    return (
        <Column spacing={1} fullWidth >
            {optionsWithGroups.map((optionGroup) => {
                const { options, optionGroupId } = optionGroup;
                return (
                    <Fragment key={optionGroupId}>
                        {options.map((option) => {
                            const itemOption = toItemOption(option);
                            return (
                                <SelectedOptionRow orderOption={option}
                                    itemOption={itemOption}
                                    optionGroupId={optionGroupId}
                                    itemId={itemId}
                                    key={`${option.shopOptionId} ${optionGroupId}`} />
                            );
                        })}
                    </Fragment>
                );
            })}
        </Column>
    );
}

function toItemOption(option: OrderOption): ItemOption {
    return {
        optionId: option.shopOptionId,
        name: option.optionName,
        basePrice: option.optionPrice,
        salePrice: option.optionPrice,
        isDefault: false,
        isChangeable: true,
        imageUrls: [],
        maxQuantity: option.maxQuantity,
        posId: option.posId,
        rewardPolicy: {
            rewardType: option.rewardType,
            rewardAmount: option.rewardAmount,
        },
    };
}

export default SelectedPersonalOptionList;
